import SlimSelect from 'slim-select';
import {Modal} from 'bootstrap';
import datepicker from 'js-datepicker'

const copyCoupon = (block) => {
    if(document.querySelectorAll(block)) {
        const copyButton = document.querySelector('.js-coupon-code-btn');
        const copyText = document.querySelector('.js-coupon-code-text');
        const tooltip = document.querySelector('.js-coupon-code-tooltip');
        copyButton?.addEventListener('click', () => {
            let inp = document.createElement('input');
            document.body.appendChild(inp)
            inp.value = copyText.textContent
            inp.select();
            document.execCommand('copy', false);
            inp.remove();

            tooltip.classList.add('show');
            setTimeout(() => tooltip.classList.remove('show'), 1000);
        })
    }
}

const modalTarget = (id) => {
    if(document.querySelector(id)) {
        const filterModal = new Modal(document.querySelector(id));
    }
}

const setCustomSelect = () => {
    const selects = document.querySelectorAll('select');

    if(selects.length > 0) [
        selects.forEach(select => {
            new SlimSelect({
                select: `#${select.getAttribute('id')}`
            })
        })
    ]
}

const toggleState = () => {
    blocksToChangeState.forEach(blockClass => {
        const block = document.querySelector(`.js-${blockClass}`);
        const btns = document.querySelectorAll(`.js-${blockClass}-button`);

        if (block && btns.length > 0) {
            btns.forEach(btn => btn.addEventListener('click', () => block.classList.toggle(`${blockClass}--opened`)));
        }
    });
}

const setDatePicker = (classes) => {
    classes.forEach(classBlock => {
        const el = document.querySelector(classBlock);
        const pickerConfig = {
            id: 1,
            formatter: (input, date, instance) => {
                const value = date.toLocaleDateString('uk-UA')
                input.value = value
            },
            customDays: ['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Нд'],
            customMonths: ['Січень', 'Лютий', 'Березень', 'Квітень', 'Травень', 'Червень', 'Липень', 'Серпень', 'Вересень', 'Жовтень', 'Листопад', 'Грудень'],
            overlayPlaceholder: 'Введіть рік'
        }
    
        if(el) {
            const picker = datepicker(el, pickerConfig)
        }
    })
}

const modals = ['#filterModal'];
const blocksToChangeState = ['navbar', 'dashboard-aside'];
const datePickers = ['.input-daterange .datepicker--birth', '.input-daterange .datepicker--start', '.input-daterange .datepicker--end']

document.addEventListener('DOMContentLoaded', () => {
    copyCoupon('.coupon-page');
    modals.forEach(id => modalTarget(id));
    setCustomSelect();
    toggleState();
    setDatePicker(datePickers);
})
